import React from 'react'

import { useIsCompanyProfilePage } from '@/components/misc/CompanyProfile/hooks/useIsCompanyProfilePage'
import Accreditations from '@/components/misc/CompanyProfile/tabs/OverviewTab/Accreditations'
import AtAGlance from '@/components/misc/CompanyProfile/tabs/OverviewTab/AtAGlance'
import BriefHistory from '@/components/misc/CompanyProfile/tabs/OverviewTab/BriefHistory'
import Locations from '@/components/misc/CompanyProfile/tabs/OverviewTab/Locations'
import { CompanyProfileItem } from '@/types/responses/companies'

interface Props {
  companyProfile: CompanyProfileItem
}

const OverviewTab: React.FC<Props> = ({ companyProfile }) => {
  const { company } = companyProfile
  const isCompanyProfilePage = useIsCompanyProfilePage()
  const briefHistory = company?.briefHistory || ''

  function renderForPartnerModal() {
    return (
      <>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <AtAGlance companyProfile={companyProfile} />
          </div>

          <div>
            <Accreditations
              companyProfile={companyProfile}
              badgesClassName="flex flex-row md:flex-col flex-wrap items-start gap-2 mb-4 mb-md-4"
            />

            {briefHistory && (
              <BriefHistory briefHistory={company?.briefHistory || ''} />
            )}
          </div>
        </div>

        <Locations companyProfile={companyProfile} />
      </>
    )
  }

  function renderForProfilePage() {
    return (
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
        <div>
          <AtAGlance companyProfile={companyProfile} />
        </div>

        <div className="xl:pl-12">
          <div className="mt-6 xl:mt-0 xl:mb-6">
            <Accreditations
              companyProfile={companyProfile}
              badgesClassName="flex flex-row flex-wrap gap-2"
            />
          </div>

          {briefHistory && (
            <div className="mt-6 xl:mt-4">
              <BriefHistory briefHistory={company?.briefHistory || ''} />
            </div>
          )}

          <Locations companyProfile={companyProfile} />
        </div>
      </div>
    )
  }

  return (
    <div className="pb-4">
      {isCompanyProfilePage ? renderForProfilePage() : renderForPartnerModal()}
    </div>
  )
}

export default OverviewTab
